import ScratchBlocks from 'scratch-blocks'
import { codeMode } from '../reducers/script'

const categorySeparator = '<sep gap="36"/>'

const blockSeparator = '<sep gap="36"/>' // At default scale, about 28px

const newOperators = `  <block type="operator_add">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_subtract">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_multiply">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <block type="operator_divide">
            <value name="NUM1">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
            <value name="NUM2">
                <shadow type="math_number">
                    <field name="NUM"/>
                </shadow>
            </value>
        </block>
        <sep gap="36"/>`

/* eslint-disable no-unused-vars */
const xmlEscape = function (unsafe) {
    return unsafe.replace(/[<>&'"]/g, (c) => {
        switch (c) {
            case '<':
                return '&lt;'
            case '>':
                return '&gt;'
            case '&':
                return '&amp;'
            case "'":
                return '&apos;'
            case '"':
                return '&quot;'
        }
    })
}
const events = function (isInitialSetup, isStage) {
    return `
    <category name="%{BKY_CATEGORY_EVENTS}" id="events" colour="#FFD500" secondaryColour="#CC9900">
        <block type="event_whenflagclicked"/>
    </category>
    `
}

const control = function (isInitialSetup, isStage) {
    return `
    <category name="%{BKY_CATEGORY_CONTROL}" id="control" colour="#FFAB19" secondaryColour="#CF8B17">
        <block type="control_wait">
            <value name="DURATION">
                <shadow type="math_positive_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
        <block type="control_repeat">
            <value name="TIMES">
                <shadow type="math_whole_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
        <block id="forever" type="control_forever"/>
        <block type="control_if"/>
        
        ${categorySeparator}
    </category>
    `
}

const operators = function (isInitialSetup) {
    const apple = ScratchBlocks.ScratchMsgs.translate(
        'OPERATORS_JOIN_APPLE',
        'apple'
    )
    const banana = ScratchBlocks.ScratchMsgs.translate(
        'OPERATORS_JOIN_BANANA',
        'banana'
    )
    const letter = ScratchBlocks.ScratchMsgs.translate(
        'OPERATORS_LETTEROF_APPLE',
        'a'
    )
    return `
    <category name="%{BKY_CATEGORY_OPERATORS}" id="operators" colour="#40BF4A" secondaryColour="#389438">

    ${codeMode && newOperators}

        <block type="operator_gt">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        <block type="operator_lt">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
        <block type="operator_equals">
            <value name="OPERAND1">
                <shadow type="text">
                    <field name="TEXT"/>
                </shadow>
            </value>
            <value name="OPERAND2">
                <shadow type="text">
                    <field name="TEXT">50</field>
                </shadow>
            </value>
        </block>
              <block type="operator_and"/>
        <block type="operator_not"/>
        
        ${categorySeparator}
    </category>
    `
}

const myBlocks = function (isInitialSetup) {
    return `
        <category
            name="%{BKY_CATEGORY_MYBLOCKS}"
            id="myBlocks"
            colour="#FF6680"
            secondaryColour="#FF4D6A"
            custom="PROCEDURE">
        </category>
        `
}

const variables = function () {
    return `
    <category
        name="%{BKY_CATEGORY_VARIABLES}"
        id="variables"
        colour="#FF8C1A"
        secondaryColour="#DB6E00"
        custom="VARIABLE">
</category>
    `
}

/* eslint-enable no-unused-vars */

const xmlOpen = '<xml style="display: none">'
const xmlClose = '</xml>'

/**
 * @param {!boolean} isInitialSetup - Whether the toolbox is for initial setup. If the mode is "initial setup",
 * blocks with localized default parameters (e.g. ask and wait) should not be loaded. (LLK/scratch-gui#5445)
 * @param {?boolean} isStage - Whether the toolbox is for a stage-type target. This is always set to true
 * when isInitialSetup is true.
 * @param {?string} targetId - The current editing target
 * @param {?Array.<object>} categoriesXML - optional array of `{id,xml}` for categories. This can include both core
 * and other extensions: core extensions will be placed in the normal Scratch order; others will go at the bottom.
 * @property {string} id - the extension / category ID.
 * @property {string} xml - the `<category>...</category>` XML for this extension / category.
 * @param {?string} costumeName - The name of the default selected costume dropdown.
 * @param {?string} backdropName - The name of the default selected backdrop dropdown.
 * @param {?string} soundName -  The name of the default selected sound dropdown.
 * @returns {string} - a ScratchBlocks-style XML document for the contents of the toolbox.
 */
const makeToolboxXML = function (
    isInitialSetup,
    isStage = true,
    targetId,
    categoriesXML = [],
    costumeName = '',
    backdropName = '',
    soundName = ''
) {
    isStage = isInitialSetup || isStage
    const gap = [categorySeparator]

    costumeName = xmlEscape(costumeName)
    backdropName = xmlEscape(backdropName)
    soundName = xmlEscape(soundName)

    categoriesXML = categoriesXML.slice()
    const moveCategory = (categoryId) => {
        const index = categoriesXML.findIndex(
            (categoryInfo) => categoryInfo.id === categoryId
        )
        if (index >= 0) {
            // remove the category from categoriesXML and return its XML
            const [categoryInfo] = categoriesXML.splice(index, 1)
            return categoryInfo.xml
        }
        // return `undefined`
    }
    const eventsXML =
        moveCategory('event') || events(isInitialSetup, isStage, targetId)
    const controlXML =
        moveCategory('control') || control(isInitialSetup, isStage, targetId)
    const operatorsXML =
        moveCategory('operators') ||
        operators(isInitialSetup, isStage, targetId)
    const myBlocksXML =
        moveCategory('procedures') ||
        myBlocks(isInitialSetup, isStage, targetId)
    const variablesXML =
        moveCategory('data') || variables(isInitialSetup, isStage, targetId)
    const everything = [xmlOpen, eventsXML, gap, controlXML, gap, operatorsXML]

    //only for code mood push bellow variabel and make a block
    if (codeMode) {
        everything.push(gap, variablesXML, gap, myBlocksXML)
    }

    for (const extensionCategory of categoriesXML) {
        everything.push(gap, extensionCategory.xml)
    }

    everything.push(xmlClose)
    return everything.join('\n')
}

export default makeToolboxXML
